import React from "react"
import { experties } from "../../config"

export default () => (
    <div id="experties">
        <img alt="curve" className="img-fluid w-100" src="./curve-v.svg" style={{ transform: "scale(-1)", marginBottom: "-1px" }} />
        <div className="py-4" style={{ backgroundColor: "rgb(134, 55, 112)" }}>
            {
                experties.map((experty, index) => (
                    <div key={index} className={["row no-gutters px-2 py-4", (index % 2) ? "justify-content-end" : ""].join(" ")}>
                        <div className={["row no-gutters col-md-8", (index % 2) ? "flex-row-reverse" : ""].join(" ")}>
                            <div className="col-6 d-flex justify-content-center">
                                <img alt="Rishi Vedpathak" src={experty.image} className="img-fluid" style={{ width: "80%" }} />
                            </div>
                            <div className="col-6 d-flex align-items-center px-4">
                                <h4>{experty.description}</h4>
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
        <img alt="curve" className="img-fluid w-100" src="./curve-v.svg" style={{ marginTop: "-1px" }} />
    </div>
)